import { Button, Card } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import SearchInput from "./SearchInput";
import JobPostListing from "./JobPostListing";
import { useNavigate, useLocation } from "react-router-dom";
import {
  findAllJobPostDto,
  Pagination,
  PositionWithOpeningCount,
} from "../../../Interface/Index";
import { JobDescription } from "../../../Entities/job-description.entity";
import PositionsDrawer from "./PositionsDrawer";

interface ListingPageContentProps {
  handleSearch: (query: string) => void;
  appliedJobPostIds: string[];
  filters: findAllJobPostDto;
  handleApply: (jobId: string) => void;
  handleViewDetails: (jobId: string) => void;
  handlePageChange: (page: number) => void;
  jobDescriptions: JobDescription[];
  pagination: Pagination;
  positionsWithOpeningCount: PositionWithOpeningCount[];
  setFilters: React.Dispatch<React.SetStateAction<findAllJobPostDto>>;
}

const ListingPageContent: React.FC<ListingPageContentProps> = ({
  handleSearch,
  appliedJobPostIds,
  filters,
  handleApply,
  handleViewDetails,
  handlePageChange,
  jobDescriptions,
  pagination,
  positionsWithOpeningCount,
  setFilters,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTabInQuery = searchParams.get("tab") || "all-job-post";

  const [jobPositionDrawerOpen, setJobPositionDrawerOpen] = useState(false);

  const handleJobPositionDrawerOpen = () => {
    setJobPositionDrawerOpen(true);
  };

  const handleJobPositionDrawerClose = () => {
    setJobPositionDrawerOpen(false);
  };

  const handleTabChange = (key: string) => {
    searchParams.set("tab", key);
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const tabItems = [
    {
      key: "all-job-post",
      label: "All Jobs",
      children: (
        <JobPostListing
          type="all-job-post"
          appliedJobPostIds={appliedJobPostIds}
          filters={filters}
          handleApply={handleApply}
          handleViewDetails={handleViewDetails}
          handlePageChange={handlePageChange}
          jobDescriptions={jobDescriptions}
          pagination={pagination}
        />
      ),
    },
    {
      key: "applied-job-post",
      label: "Applied Jobs",
      children: (
        <JobPostListing
          type="applied-job-post"
          appliedJobPostIds={appliedJobPostIds}
          filters={filters}
          handleApply={handleApply}
          handleViewDetails={handleViewDetails}
          handlePageChange={handlePageChange}
          jobDescriptions={jobDescriptions}
          pagination={pagination}
        />
      ),
    },
  ];

  const activeTab = tabItems.find((tab) => tab.key === currentTabInQuery)
    ? currentTabInQuery
    : "all-job-post";

  return (
    <Card
      className="listing_page_content_card"
      bordered={true}
      title={
        <div>
          <div className="listing_page_card_header">
            <Title level={4} style={{ margin: 0 }}>
              Job Openings
            </Title>
            <div className="position_filter_menu_button">
              <Button type="primary" onClick={handleJobPositionDrawerOpen}>
                Positions
              </Button>
            </div>
            <div className="desktop_search_input">
              <SearchInput onSearch={handleSearch} />
            </div>
          </div>
          <div className="mobile_search_input">
            <SearchInput onSearch={handleSearch} />
          </div>
        </div>
      }
      tabProps={{
        size: "small",
      }}
      tabList={tabItems}
      activeTabKey={activeTab}
      onTabChange={handleTabChange}
    >
      <PositionsDrawer
        filters={filters}
        setFilters={setFilters}
        isOpen={jobPositionDrawerOpen}
        handleDrawerClose={handleJobPositionDrawerClose}
        positionsWithOpeningCount={positionsWithOpeningCount}
      />
    </Card>
  );
};

export default ListingPageContent;
